module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h4', [_vm._v("User Profile")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "bold"
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userProfile.first_name) + " " + _vm._s(_vm.userProfile.last_name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bold"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userProfile.email))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bold"
  }, [_vm._v("Roles")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roles))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d6a4b4f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
// module id = 486
// module chunks = 2